import { Fragment } from "react";

/**
 * 커리큘럼 데이터 문구의 최소 표기를 React 노드로 변환한다.
 * - `\n`      -> <br />
 * - `**강조**` -> <b>강조</b>
 *
 * dangerouslySetInnerHTML 없이 원본 디자인의 줄바꿈/강조를 재현하기 위한 장치라
 * 위 두 가지 외의 표기는 의도적으로 지원하지 않는다.
 */
export default function CurriculumText({ children }) {
    const text = String(children ?? "");

    return text.split("\n").map((line, lineIndex) => (
        // eslint-disable-next-line react/no-array-index-key
        <Fragment key={lineIndex}>
            {lineIndex > 0 ? <br /> : null}
            {line.split(/(\*\*[^*]+\*\*)/g).map((part, partIndex) =>
                part.startsWith("**") && part.endsWith("**") ? (
                    // eslint-disable-next-line react/no-array-index-key
                    <b key={partIndex}>{part.slice(2, -2)}</b>
                ) : (
                    // eslint-disable-next-line react/no-array-index-key
                    <Fragment key={partIndex}>{part}</Fragment>
                )
            )}
        </Fragment>
    ));
}
